import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

export default function(props) {
    return (
        <Grid
            className="no-shadow"
            container
            id="reduce-width"
            justify="center"
            spacing={2}
        >
            <Grid
                id="shadow-round"
                item
                sm={8}
                xs={12}
            >
                <Button
                    aria-label="add"
                    className={props.className}
                    disabled={props.disabled}
                    fullWidth
                    id={props.id}
                    onClick={props.onClick}
                    style={props.style}
                    type={props.type}
                    variant={props.variant ? props.variant : ''}
                >
                    {props.children}
                </Button>
            </Grid>
        </Grid>
    );
}
